export const FETCH_APPOINTMENT_CLIENT_DATA = "FETCH_APPOINTMENT_CLIENT_DATA";
